import { Injectable } from '@angular/core';
import { BaseDownloadServiceWithFilter } from '.';
import { HelpMaterial } from '@cl/shared/models/help-materials/help-material.model';
import { HelpMaterialFilter } from '@cl/shared/models/help-materials/help-material-filter.model';
import { NzImageService } from 'ng-zorro-antd/image';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { CommandResult } from '@cl/shared/models';
import { FileMetadata } from '@cl/shared/models/file.model';
import { UsersHelpMaterials } from '@cl/shared/models/help-materials/users-help-materials.model';

@Injectable({
    providedIn: 'root',
})
export class HelpMaterialsService extends BaseDownloadServiceWithFilter<HelpMaterial, HelpMaterialFilter> {
    constructor(
        protected httpClient: HttpClient,
        protected nzImageService: NzImageService,
    ) {
        super(httpClient, '/api/v1/help-materials/', nzImageService);
    }

    async updateHelpMaterial(helpMaterial: FormData): Promise<void> {
        return lastValueFrom(this.httpClient.put<void>(this.baseApiUrl, helpMaterial));
    }

    async downloadFile(helpMaterialId: number): Promise<void> {
        return this.handleFileDownloading(
            lastValueFrom(this.httpClient.get<CommandResult<FileMetadata>>(`${this.baseApiUrl}download/${helpMaterialId}`)),
        );
    }

    async getUsersHelpMaterials(): Promise<CommandResult<UsersHelpMaterials>> {
        return lastValueFrom(this.httpClient.get<CommandResult<UsersHelpMaterials>>(`${this.baseApiUrl}users-help-materials`));
    }
}
